export default __webpack_public_path__ + "static/media/FbMessenger.b85d9d76.png";